import React, { Suspense } from 'react';
import SectionSale from './sections/section-sale';
import SectionLTV from './sections/section-ltv';
import SectionTrackingUser from './sections/section-tracking-user';
import SectionDauMau from './sections/section-dau-mau';
import SectionUserSaleData from './sections/section-user-sale-data';
import SectionCardTotal from './sections/section-card-total';
import SkeletonCardTotalList from './sekeletons/skeleton-card-total';
import SectionUser from './sections/section-user';
import SectionRecommendCard from './sections/recommend/setion-recommend-card';
import SectionUserActivityPanel from './sections/visits/section-user-activity-panel';
export default function DashBoard() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-full overflow-x-hidden bg-[#f5f5f5]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container mx-auto max-w-[1680px] px-[30px] grid gap-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "border mt-4 p-4 bg-white"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-4xl"
    }, "\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9")), /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonCardTotalList, null)
    }, /*#__PURE__*/ React.createElement(SectionCardTotal, null)), /*#__PURE__*/ React.createElement(SectionSale, null), /*#__PURE__*/ React.createElement(SectionUser, null), /*#__PURE__*/ React.createElement(SectionLTV, null), /*#__PURE__*/ React.createElement(SectionTrackingUser, null), /*#__PURE__*/ React.createElement(SectionDauMau, null), /*#__PURE__*/ React.createElement(SectionRecommendCard, null), /*#__PURE__*/ React.createElement(SectionUserSaleData, null), /*#__PURE__*/ React.createElement(SectionUserActivityPanel, null)));
}
